<style lang="scss" scoped>
.dropdown-item {
  &[disabled] {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &[disabled] {
      cursor: not-allowed;
    }
  }
}
</style>

<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div class="dropdown-item" @click="remove" :disabled="deleting">
          Rundmail löschen
        </div>
        <div
          v-if="!model.sent"
          class="dropdown-item"
          @click="update"
          :disabled="deleting"
        >
          Rundmail bearbeiten
        </div>
        <div
          v-if="model.sent"
          class="dropdown-item"
          @click="receiver"
          :disabled="deleting"
        >
          Rundmail Empfänger
        </div>
        <div
          class="dropdown-item"
          @click="showSettings = true"
          :disabled="deleting"
        >
          Rundmail Einstellungen
        </div>
        <div class="dropdown-item" @click="edit" :disabled="deleting">
          Unbeachtete neu anschreiben
        </div>
      </div>
      <CircularMailSettingsModal
        :show.sync="showSettings"
        v-bind="model"
      ></CircularMailSettingsModal>
    </div>
  </td>
</template>

<script lang="babel">
import { catchOutsideClicks } from "@/js/bodyClick.js";
import CircularMailSettingsModal from "@/components/modals/CircularMailSettingsModal";

export default {
    components: {
      CircularMailSettingsModal
    },
    props: ['content', 'label', 'model'],
    data() {
      return {
        show: false,
        changingActivation: false,
        deleting: false,
        showSettings: false
      };
    },
    mounted() {
      catchOutsideClicks(this.$refs.dropdown, () => {
        this.show = false;
      });
    },
    methods: {
      edit() {
        if (this.removing) {
          return;
        }
        this.$router.push({ path: `/rundmail/unbeachteteNeuAnschreiben/${this.model.id}` });
      },
      update() {
        if (this.removing) {
          return;
        }
        this.$router.push({ path: `/rundmail/${this.model.id}` });
      },
      receiver() {
        if (this.removing) {
          return;
        }
        this.$router.push({ path: `/rundmail/empfänger/${this.model.id}` });
      },
      remove() {
        if (this.removing) {
          return;
        }

        let confirmed = confirm('Sicher?');
        if (!confirmed) {
          return;
        }

        this.removing = true;

        this.$store.dispatch('circularMail/delete', { url: this.model.delete_url, id: this.model.id}).then(() => {
          this.$emit('table-update', { count: true });
        }).finally(() => {
          this.removing = false;
        });
      }
    }
};
</script>
